const STORAGE_KEY = 'horizon:selected-size';
const GATED_SELECTOR = '[data-expected-size-gated="true"]';
const GROUP_SELECTOR = 'product-swatches fieldset, variant-picker fieldset, variant-picker select';

function normalizeSize(value) {
  const text = String(value || '').trim();
  const match = text.match(/^(?:size\s*)?([0-7])(?:\b|\s|\()/i);
  return match ? match[1] : text.toLowerCase();
}

function expectedSize() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (!stored) return '';
    try {
      const parsed = JSON.parse(stored);
      return normalizeSize(parsed?.size || parsed?.value || '');
    } catch {
      return normalizeSize(stored);
    }
  } catch {
    return '';
  }
}

function isSelected(element) {
  return element.matches('option') ? element.selected : Boolean(element.querySelector('input:checked'));
}

function applyGroup(group, size) {
  const choices = Array.from(group.children).filter((element) =>
    element.matches('li.variant-option__swatch, label.variant-option__button-label, option')
  );
  const gated = choices.filter((element) => element.matches(GATED_SELECTOR));
  if (!gated.length) return;

  const matching = gated.filter((element) =>
    size && element.dataset.expectedSizeValues.split('|').some((value) => normalizeSize(value) === size)
  );
  const fallback = matching.length === 0 && choices.length === gated.length
    ? gated.find(isSelected) || gated[0]
    : null;

  for (const element of gated) {
    element.hidden = !matching.includes(element) && element !== fallback;
    element.dataset.expectedSizeReady = 'true';
  }
}

function applyExpectedSize(root = document) {
  const size = expectedSize();
  if (root.matches?.(GROUP_SELECTOR)) applyGroup(root, size);
  for (const group of root.querySelectorAll?.(GROUP_SELECTOR) || []) applyGroup(group, size);
}

function applyAddedNode(node) {
  if (!(node instanceof Element)) return;
  if (node.matches(GROUP_SELECTOR) || node.querySelector(GROUP_SELECTOR)) {
    applyExpectedSize(node);
    return;
  }
  const group = node.closest(GROUP_SELECTOR);
  if (group && (node.matches(GATED_SELECTOR) || node.querySelector(GATED_SELECTOR))) {
    applyGroup(group, expectedSize());
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => applyExpectedSize(), { once: true });
} else {
  applyExpectedSize();
}

document.addEventListener('horizon:expected-size-change', () => applyExpectedSize());
document.addEventListener('shopify:section:load', (event) => applyExpectedSize(event.target));
window.addEventListener('pageshow', () => applyExpectedSize());
window.addEventListener('storage', (event) => {
  if (event.key === STORAGE_KEY) applyExpectedSize();
});

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      applyAddedNode(node);
    }
  }
});
observer.observe(document.documentElement, { childList: true, subtree: true });
